import type { Config } from "@twilio/flex-ui";

const appConfig: Config = {
    pluginService: {
        enabled: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // The following property seems to work, even though it doesn't seem
        // to be document by Twilio Flex types ...
        url: "/plugins.json",
    },
    sso: {
        accountSid: "AC33274c3c6802b1a76bca2df04dad494a",
    },
    // Enhanced SSO (OAuth 2.0), see CS-703. Flex UI switches to the enhanced
    // login flow as soon as this object is present, so this must not be
    // deployed to flex.wave.com until the Console + IdP migration is done.
    // Twilio says to keep the legacy `sso` block above alongside `oauth`.
    // Values come from:
    // https://services.twilio.com/v1/Flex/Authentication/Config?AccountSid=AC33274c3c6802b1a76bca2df04dad494a
    oauth: {
        connection: "JQ66007d3a1978522ecb7017231a2c4e6c",
        clientId: "XVO9zVKsUzbpLtz112e5oYTNluSdhcEY",
        redirectUrl: "https://flex.wave.com",
    },
    logLevel: "info",
};

export default appConfig;
